import CrudApiClient from '../crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from '../axios';
import { ISkuUploadInput, ISKUUploadRequest } from '@admin-panel/types';

class SkuUploadAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/sku/upload');
  }

  async search(query: any, page: number, size: number): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async create(payload: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async updateById(id: any, data: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findBulk(ids: any[]): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findById(id: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  // @ts-ignore
  async createMany(payload: ISkuUploadInput[], meta: MetaQuery | undefined): Promise<any> {
    try {
      const { category, vendorId, dryRun, brand }: any = meta;
      const skuUploadRequest: ISKUUploadRequest = {
        uploadCategory: category,
        vendorId,
        brandName: brand,
        dryRun,
        skus: payload,
      };

      const response = await axiosInstance.post(`${this.baseURL}`, skuUploadRequest);
      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error creating entities in bulk:`, error);
      throw error;
    }
  }
}

export default SkuUploadAPIClient;
